<template>
  <v-layout>
    <v-flex shrink>
      <v-card width="250px" class="elevation-5 mb-3">
        <v-list class="py-0" style="background-color: #000">
          <v-list-tile>
            <v-list-tile-title
              style="text-align: center; font-size: 20px; color: white"
              >REPORT</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
        <!-- <v-list dark class="py-0" style="background-color: #424242">
          <v-list-tile
            v-for="item in filteredSidebar"
            :key="item.title"
            :to="item.link"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="white--text">{{
              item.title
            }}</v-list-tile-content>
          </v-list-tile>
        </v-list> -->

        <v-list
          dark
          class="py-0"
          style="overflow: hidden; background-color: #424242"
        >
          <div
            v-for="item in filteredSidebar"
            :key="item.title"
            :prepend-icon="item.icon"
            no-action
          >
            <v-list-tile slot="activator" :to="item.link">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <div v-if="$route.fullPath.includes('reportdashboard/main')">
              <v-divider color="white" class="mx-4"></v-divider>
              <v-list-tile
                v-for="subItem in filteredSubSidebar(item)"
                :key="subItem.title"
                :to="subItem.link"
              >
                <v-list-tile-action> </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="subItem.alert">
                  <v-btn
                    fab
                    color="primary"
                    style="height: 25px; width: 25px"
                    class="black--text"
                  ></v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </div>
          </div>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      groupMenuItems: [
        {
          icon: "assessment",
          permission_name: "main",
          title: "Main dashboard",
          link: "/weserve_admin_login/-/reportdashboard/main",
          children: [
            {
              icon: "assessment",
              permission_name: "report_reward",
              title: "Reward report",
              link: "/weserve_admin_login/-/reportdashboard/main/reward-report",
            },
            {
              icon: "assessment",
              permission_name: "packages_report",
              title: "Package report",
              link: "/weserve_admin_login/-/reportdashboard/main/packages-report",
            },
            {
              icon: "assessment",
              permission_name: "connect_wallet_report",
              title: "Connect wallet",
              link: "/weserve_admin_login/-/reportdashboard/main/connect-wallet-report",
            },
            {
              icon: "assessment",
              permission_name: "wellness_report",
              title: "Wellness Report",
              link: "/weserve_admin_login/-/reportdashboard/main/wellness-report",
            },
            {
              icon: "assessment",
              permission_name: "order_dineIn_report",
              title: "Order Dine In Report",
              link: "/weserve_admin_login/-/reportdashboard/main/dine-in-report",
            },
            {
              icon: "assessment",
              permission_name: "order_dineIn_report",
              title: "Dine In sale store",
              link: "/weserve_admin_login/-/reportdashboard/main/dine-in-sale-store",
            },
          ],
        },
      ],
    };
  },
  methods: {},
  computed: {
    ...mapState({
      selectedMenu: (state) => state.backOffice.selectedMenu,
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      return this.groupMenuItems.filter(
        (val) =>
          val.permission_name in this.permission.main_menu.report_dashboard
      );
    },
  },
  methods: {
    filteredSubSidebar(item) {
      return item.children.filter(
        (val) =>
          val.permission_name in
          this.permission.main_menu.report_dashboard[item.permission_name]
      );
    },
  },
};
</script>
